const c = "mbc";
export {
  c as PREFIX
};
